import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import LanguageSelector from './LanguageSelector';
import styles from './PageHeader.module.css';

export default function PageHeader({ title, subtitle, backTo = '/dashboard' }) {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.topRow}>
        <button className={styles.backBtn} onClick={() => navigate(backTo)} aria-label="Back">
          <FaArrowLeft />
        </button>
        <LanguageSelector />
      </div>
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
}
